import React from 'react';

const highlights = [
  {
    icon: 'fa-receipt',
    title: 'Cost + 30%',
    description: 'We pass through provider rates at negotiated volume pricing, plus a 30% platform fee. No hidden charges.',
  },
  {
    icon: 'fa-bolt',
    title: '$15 to Start',
    description: 'Prepaid balance loaded at sign-up. No contracts, no minimums. Auto top-up available. All prices in USD.',
  },
  {
    icon: 'fa-key',
    title: 'Bring Your Own Keys',
    description: 'Use your own OpenAI, Deepgram, GroqCloud, or Twilio accounts and pay only for platform compute.',
  },
];

const included = [
  'Dedicated ECS container, Redis database & DynamoDB tables',
  'Full data isolation — no shared infrastructure between accounts',
  'Automated infrastructure provisioning',
  'Phone number management',
  'Automated regression testing & simulation',
  'FAQ optimization & content gap analysis',
  'Real-time usage dashboard & analytics',
  'Call logs with full transcripts',
  'Staff coordination (SMS bridge)',
  'Calendar & payment integrations',
  'API documentation & code samples',
  'Platform updates & maintenance',
];

const Pricing = ({ onNavigateLogin }) => {
  return (
    <div id="pricing" className="px-8 py-20 bg-[#f9f9fb]">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="text-3xl lg:text-4xl font-bold font-['Montserrat'] text-[#222324] mb-4">
            Transparent Pricing
          </h2>
          <p className="text-gray-600 text-lg font-medium font-['Inter'] max-w-2xl mx-auto">
            Usage-based pricing with full cost visibility. Pay only for what your assistants use, calculated hourly from your prepaid balance.
          </p>
        </div>

        {/* Value prop cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {highlights.map((item) => (
            <div key={item.title} className="bg-white rounded-xl border border-gray-200 p-6 text-center">
              <div className="w-12 h-12 bg-[#055EFD]/10 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className={`fa-solid ${item.icon} text-[#055EFD] text-xl`}></i>
              </div>
              <h3 className="text-[#222324] text-lg font-bold font-['Montserrat'] mb-2">{item.title}</h3>
              <p className="text-gray-500 text-sm font-medium font-['Inter'] leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>

        {/* Architecture advantage + CTA */}
        <div className="bg-white rounded-xl border border-gray-200 p-8 mb-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-[#222324] text-xl font-bold font-['Montserrat'] mb-3">
                Zero Cold Starts. Pay-Per-Call.
              </h3>
              <p className="text-gray-600 text-sm font-['Inter'] leading-relaxed mb-4">
                Our gateway architecture answers every call instantly while dedicated containers scale in the background. No caller ever waits, no idle infrastructure burns your budget.
              </p>
              <div className="flex flex-col gap-2">
                <div className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-green-500 text-xs"></i>
                  <span className="text-[#222324] text-sm font-medium font-['Inter']">Scale to zero between calls</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-green-500 text-xs"></i>
                  <span className="text-[#222324] text-sm font-medium font-['Inter']">Dedicated infrastructure per account</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-green-500 text-xs"></i>
                  <span className="text-[#222324] text-sm font-medium font-['Inter']">Working hours scheduling to reduce costs</span>
                </div>
              </div>
            </div>
            <div className="text-center">
              <a
                href="/pricing-calculator"
                className="inline-flex items-center gap-3 px-8 py-4 bg-[#055EFD] rounded-xl text-white text-lg font-bold font-['Inter'] hover:bg-[#0449d4] transition-colors shadow-lg shadow-[#055EFD]/20"
              >
                <i className="fa fa-calculator"></i>
                Calculate Your Costs
              </a>
              <p className="text-gray-500 text-xs font-['Inter'] mt-3">
                Estimate monthly costs based on your call volume, schedule, and provider preferences
              </p>
            </div>
          </div>
        </div>

        {/* Included features */}
        <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
          <div className="bg-neutral-800 p-6">
            <h3 className="!text-white text-xl font-bold font-['Montserrat'] mb-2">Included With Every Account</h3>
            <p className="!text-stone-300 text-sm font-['Inter']">No extra charges for platform features</p>
          </div>
          <div className="p-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              {included.map((item) => (
                <div key={item} className="flex items-start gap-3">
                  <i className="fa fa-check text-green-500 text-sm mt-0.5"></i>
                  <span className="text-[#222324] text-sm font-medium font-['Inter']">{item}</span>
                </div>
              ))}
            </div>

            <div className="mt-6 pt-6 border-t border-gray-100 flex flex-col sm:flex-row items-center justify-center gap-4">
              <button
                onClick={() => onNavigateLogin(true)}
                className="px-8 py-3 bg-[#055EFD] rounded-lg text-white text-sm font-bold font-['Inter'] hover:bg-[#0449d4] transition-colors"
              >
                Get Started -- $15 to Start Building
              </button>
              <p className="text-gray-500 text-xs font-['Inter']">
                No contracts. No minimum commitment.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pricing;
